import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preise',
  templateUrl: './preise.component.html',
  styleUrls: ['./preise.component.css']
})
export class PreiseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/AnnaNorbisrath/WebstormProjects/me.rainer.surfschule-wiesensee/src/app/preise/preise.component.ts